import { toast } from "react-toastify";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import { ADD_CLIENTS, ADD_CLIENTS_FAILED, ADD_CLIENTS_SUCCESS, CLIENTS, CLIENTS_FAILED, CLIENTS_SUCCESS, SEARCHEDCLIENT, SEARCHEDCLIENT_FAILED, SEARCHEDCLIENT_SUCCESS, SINGLE_CLIENTS, SINGLE_CLIENTS_FAILED, SINGLE_CLIENTS_SUCCESS, UPDATE_CLIENTS, UPDATE_CLIENTS_FAILED, UPDATE_CLIENTS_SUCCESS } from "./actionTypes";

export const getClients = (params) => async dispatch => {
    dispatch({
        type: CLIENTS
    })
    try {
        let response = await api(`clients/all/${params}`, 'get', {}, getAuthHeader())
        console.log('clients data', response);
        dispatch({
            type: CLIENTS_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while fetching clients error ====>>>", error);
        return dispatch({
            type: CLIENTS_FAILED,
            payload: error?.message
        })
    }
}

export const getSingleClient = (id) => async dispatch => {
    dispatch({
        type: SINGLE_CLIENTS
    })
    try {
        let response = await api(`clients/client/${id}`, 'get', {}, getAuthHeader())
        console.log('single clients data', response);
        dispatch({
            type: SINGLE_CLIENTS_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while fetching single clients error ====>>>", error);
        return Promise.reject(dispatch({
            type: SINGLE_CLIENTS_FAILED,
            payload: error?.message
        }))
    }
}
export const addClient = (data) => async dispatch => {
    dispatch({
        type: ADD_CLIENTS
    })
    try {
        let response = await api(`clients/add`, 'post', data, getAuthHeader())
        console.log('add clients data', response);
        toast.success("Added Successfully");
        dispatch({
            type: ADD_CLIENTS_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while Adding clients error ====>>>", error);
        toast.error(error?.message);
        return Promise.reject(dispatch({
            type: ADD_CLIENTS_FAILED,
            payload: error?.message
        }))
    }
}
export const updateClients = (id,data) => async dispatch => {
    dispatch({
        type: UPDATE_CLIENTS
    })
    try {
        let response = await api(`clients/update/${id}`, 'put', data, getAuthHeader())
        console.log('Update clients data', response);
        toast.success("Updated Successfully");
        dispatch({
            type: UPDATE_CLIENTS_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while Updating clients error ====>>>", error);
        toast.error(error?.message);
        return Promise.reject(dispatch({
            type: UPDATE_CLIENTS_FAILED,
            payload: error?.message
        }))
    }
}

export const getSearchedClient = (inputValue) => async dispatch => {
    dispatch({
        type: SEARCHEDCLIENT
    })
    try {
      let response = await api(`clients/search?inputValue=${inputValue}`, 'post', {}, {})  
    //   console.log("serching client response ===>", response);
      dispatch({
        type: SEARCHEDCLIENT_SUCCESS,
        payload: response?.data
      })
    } catch (error) {
        console.log("while serching client error ===>", error)
        dispatch({
            type: SEARCHEDCLIENT_FAILED,
            payload: error?.message
        })
    }
}